import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { adminApi, investorApi } from '@/api';
import { MessageContext } from '@/app/MessageProvider';
import { downloadImgFromBlob, getErrorMessage } from '@/utils/helpers';

export const useTableActions = ({ referralView, referralToken }) => {
  const { t } = useTranslation();
  const messageApi = useContext(MessageContext);

  const downloadPdf = async (pdfUrl, name) => {
    try {
      const response = referralView
        ? await investorApi.downloadPdfAgent({
            url: pdfUrl,
            token: referralToken
          })
        : await adminApi.downloadPdf(pdfUrl);
      downloadImgFromBlob(response.data, `${name.split(' ').join('')}.pdf`);
    } catch (e) {
      messageApi.error(t(getErrorMessage(e)));
    }
  };

  return {
    downloadPdf
  };
};

